export const getContactMediumIconColour = (contact_medium_id) => {
    switch(contact_medium_id){
        case 1:
            return {icon: 'phone', colour: '#000'}
        case 2:
            return {icon: 'mobile', colour: '#000'}
        case 3:
            return {icon: 'at', colour: '#000'}
        case 4:
            return {icon: 'fax', colour: '#000'}
    }
}